<script lang="ts">
import { fly } from 'svelte/transition'

import TypingIndicator from '../TypingIndicator.svelte'

type Props = {
	ref?: HTMLDivElement
}

let { ref = $bindable() }: Props = $props()
</script>

<div bind:this={ref} in:fly|global={{ x: -20 }} class="flex mt-8">
	<div class="flex-center h-10 p-2 bg-slate-100 rounded-3xl">
		<TypingIndicator size="sm" color="gray" />
	</div>
</div>
